import { WizardTooltipComponent } from 'components/wizardTooltip/src'
import React from 'react'
import { useMediaQuery } from 'react-responsive'

interface IFooterBottomNavProps {
  initialized?: boolean
  setInitialized: (arg1: boolean) => void
}

const TooltipTyC = ({
  initialized = false,
  setInitialized = () => {},
}: IFooterBottomNavProps) => {
  const isMobile = useMediaQuery({ query: '(max-width: 480px)' })

  const steps = 
    {
      title: 'Aceptá los términos y condiciones',
      description: 'Para poder confirmar tu solicitud, necesitamos que aceptes los términos y condiciones de Interbanking.',
      target: 'bottomNav-Check',
      placement: 'bottom-start',
      offsetExtraY: 20,
      offsetExtraX: 100,
    }
    
  return (
    <>
    { !isMobile && 
      <WizardTooltipComponent
        id="wizard"
        steps={steps}
        initialized={initialized}
        setInitialized={setInitialized}
        width={320}
        height={147}
        isModal={true}
        color='black'
        bgColor='white'
        stylesTooltip={{ stylesTooltipTitle: 'width: 232px', stylesTooltipDesc: 'width: 260px' }}
      />
    } 
    </> 
  )
}

export default TooltipTyC

